import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Injector,
  Input,
} from '@angular/core';
import { Observable } from 'rxjs';
import { TaskWorkspaceStore } from '../../../../core/h3ml/state/task-workspace-store';
import { contentInjectorToken } from '../../annotation-shared/abstract-annotation-output-component';
import { AnnotationState2D } from '../../annotation-shared/state/root/annotation-state-2d';

@Component({
  selector: 'h3-raster-coding-toolbars',
  templateUrl: './raster-coding-toolbars.component.html',
  styleUrls: [
    '../../annotation-shared/toolbars/toolbar-grid.scss',
    './raster-coding-toolbars.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RasterCodingToolbarsComponent {
  @Input({ required: true }) state!: AnnotationState2D;
  readOnly$: Observable<boolean | undefined>;

  constructor(
    @Inject(contentInjectorToken) public contentInjector: Injector,
    store: TaskWorkspaceStore,
  ) {
    this.readOnly$ = store('readOnly').$;
  }
}
